import { z } from 'zod'

/**
 * Where a document is in its upload lifecycle. Mirrors `DocumentStatus` in
 * prisma/schema.prisma.
 *
 * The row is created BEFORE the file exists, because the browser uploads
 * straight to object storage using a pre-signed link and the API never sees the
 * bytes. PENDING therefore means "we issued an upload link"; READY means the
 * file was confirmed present in the bucket. Anything still PENDING after a
 * while is an upload that was abandoned — real, and worth being able to see
 * rather than pretending every row has a file behind it.
 */
export const DOCUMENT_STATUSES = ['PENDING', 'READY'] as const

export const documentStatusSchema = z.enum(DOCUMENT_STATUSES)

export type DocumentStatus = z.infer<typeof documentStatusSchema>
